class INTENT.widgets.Creative

  @ATTR_NAME: "data-widget-creative"

  @ATTR_FIELDS: "#{@ATTR_NAME}-moderated-fields"

  @APPROVE_STATUS: 'approved'

  constructor: (@el) ->
    @s = @.constructor

    @changed = false

    fields = jQuery.parseJSON(@el.attr(@s.ATTR_FIELDS))

    for name, row of fields
      $("[name=#{name}]").on "change" , =>
        @changed = true
      ;

    @el.on 'submit', =>
      if @changed
        message = __ 'creative.moderation.status'
        show_confirm message, @confirm, @cancel

        if @el.attr(@s.ATTR_NAME) != @s.APPROVE_STATUS
          return false

  confirm: () =>
    @el.attr @s.ATTR_NAME, @s.APPROVE_STATUS
    @el.find('[name="update"]').click()
    return true

  cancel: () =>
    @el.attr @s.ATTR_NAME, ''
    return false
